import {
    CLEAR_FILTER_LICENCES,
    FILTER_LICENCES_PENDING, FILTER_LICENCES_SUCCESS,
    GET_LICENCES_ERROR,
    GET_LICENCES_PENDING,
    GET_LICENCES_SUCCESS
} from "../actions/types";
import {useSelector} from "react-redux";

const INITIAL_STATE = {
    licences: [],
    loading: false,
    companyLicences: [],
    companyOptions: [],
    softwareProductOptions: [],
    filterValues: [],
    filteredLicences: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_LICENCES_PENDING:
            return {
                ...state,
                loading: true
            };
        case GET_LICENCES_SUCCESS:
            return {
                ...state,
                loading: false,
                licences: action.payload.licences,
                filteredLicences: action.payload.licences,
                companyOptions: action.payload.companyOptions,
                softwareProductOptions: action.payload.softwareProductOptions
            };
        case GET_LICENCES_ERROR:
            return {
                ...state,
                loading: false,
                licences: []
            };

        case FILTER_LICENCES_PENDING:
            return {
                ...state,
                filterValues: action.payload
            };
        case FILTER_LICENCES_SUCCESS:
            return {
                ...state,
                filteredLicences: action.payload
            };
        case CLEAR_FILTER_LICENCES:
            return {
                ...state,
                filterValues: []
            };

        default: return state;
    }
}

export const licenceSelector = () => state => state.licence;

export const useLicenceSelector = () => useSelector(licenceSelector());